export { default } from "./ListItemIndexDesktop";
